export default "__VITE_ASSET__K$kq_JA3__"